import React from "react";
import { Link } from "react-router-dom";
import services from "../../api/services";

const ServiceSection: React.FC = () => {
  const arrowIcon = (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6.29004" y="21.4111" width="22.36" height="2.83936" transform="rotate(-40.2798 6.29004 21.4111)" fill="white" />
      <rect x="9.44824" y="7.57031" width="2.83936" height="2.83936" transform="rotate(-40.2798 9.44824 7.57031)" fill="white" />
      <rect x="13.4492" y="7.90015" width="2.83936" height="2.83936" transform="rotate(-40.2798 13.4492 7.90015)" fill="white" />
      <rect x="17.4512" y="8.23047" width="2.83936" height="2.83936" transform="rotate(-40.2798 17.4512 8.23047)" fill="white" />
      <rect x="21.123" y="12.5627" width="2.83936" height="2.83936" transform="rotate(-40.2798 21.123 12.5627)" fill="white" />
      <rect x="20.793" y="16.5649" width="2.83936" height="2.83936" transform="rotate(-40.2798 20.793 16.5649)" fill="white" />
      <rect x="20.4619" y="20.5669" width="2.83936" height="2.83936" transform="rotate(-40.2798 20.4619 20.5669)" fill="white" />
    </svg>
  );

  return (
    <section className="service pos-rel bg_img">
      <div className="container">
        <div className="row mt-none-30">
          {services.map((service) => {
            const href = `/service/${service.slug}`;
            return (
              <div className="col-lg-6 mt-30" key={service.id}>
                <div className="xb-ser-item xb-border img-hove-effect">
                  <div className="xb-item--inner">
                    <h3 className="xb-item--title border-effect">
                      <Link to={href}>{service.title}</Link>
                    </h3>

                    <Link className="xb-item--icon" to={href}>
                      {arrowIcon}
                    </Link>

                    <p className="xb-item--content">{service.shortDesc}</p>

                    <div className="xb-item--img xb-img">
                      {[0, 1, 2, 3].map((i) => (
                        <Link key={i} to={href}>
                          <img src={service.cardImg} alt={service.title} />
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
